<template>
  <section class="banner" @mouseenter="pauseLunbo" @mouseleave="startLunbo">
    <div class="carousel-container"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd">
      <div class="carousel-track" :style="trackStyle">
        <!-- 幻灯片1: 辐射监测产品 -->
        <div class="carousel-slide slide-1">
          <div class="slide-content">
            <div class="part-01">
              <div class="media-wrapper">
                <div class="top-section">
                  <div class="slogan">
                    <h1>{{ $t("banner_slogan_line1") }}</h1>
                    <p class="slogan-en">
                      {{ $t("banner_slogan_line2") }}<br />
                      {{ $t("banner_slogan_line3") }}
                    </p>
                  </div>
                </div>
                <div class="products-section">
                  <div class="product-grid-1">
                    <div class="product-item gray">
                      <div class="product-name">RadTarge-Mini</div>
                      <div class="product-desc">
                        {{ $t("product_radtarge_mini") }}
                      </div>
                    </div>
                    <div class="product-item white">
                      <div class="product-name">RadTarge</div>
                      <div class="product-desc">
                        {{ $t("product_radtarge") }}
                      </div>
                    </div>
                    <div class="product-item white product-item-img-large">
                      <img :src="banner01" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="part-02">
              <div class="media-wrapper">
                <div class="products-section">
                  <div class="product-grid-2">
                    <div class="product-item red">
                      <div class="product-name">RadWall</div>
                      <div class="product-desc">
                        {{ $t("product_radwall") }}
                      </div>
                    </div>
                    <div class="product-item gray">
                      <div class="product-name">RadHFC</div>
                      <div class="product-desc">{{ $t("product_radhfc") }}</div>
                    </div>
                    <div class="product-item product-item-spacer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 幻灯片2: PET/CT产品 -->
        <div class="carousel-slide slide-2">
          <div class="slide-content">
            <div class="part-01">
              <div class="media-wrapper">
                <div class="top-section">
                  <div class="slogan">
                    <h1>{{ $t("banner_slogan_line1") }}</h1>
                    <p class="slogan-en">
                      {{ $t("banner_slogan_line2") }}<br />
                      {{ $t("banner_slogan_line3") }}
                    </p>
                  </div>
                </div>
                <div class="products-section">
                  <div class="product-grid-1">
                    <div class="product-item gray">
                      <div class="product-name">{{ $t("trans_pet_name") }}</div>
                      <div class="product-desc">{{ $t("trans_pet_desc") }}</div>
                    </div>
                    <div class="product-item white">
                      <div class="product-name">Trans-PET</div>
                      <div class="product-desc">Discoverist 180</div>
                    </div>
                    <div class="product-item white product-item-img-large">
                      <img :src="banner02" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="part-02">
              <div class="media-wrapper">
                <div class="products-section">
                  <div class="product-grid-2">
                    <div class="product-item red">
                      <div class="product-name">Trans-PET</div>
                      <div class="product-desc">Discoverist 80</div>
                    </div>
                    <div class="product-item gray">
                      <div class="product-name">Trans-PET</div>
                      <div class="product-desc">Explorist 180</div>
                    </div>
                    <div class="product-item product-item-spacer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 幻灯片3: 探测器技术 -->
        <div class="carousel-slide slide-3">
          <div class="slide-content">
            <div class="part-01">
              <div class="media-wrapper">
                <div class="top-section">
                  <div class="slogan">
                    <h1>{{ $t("banner_slogan_line1") }}</h1>
                    <p class="slogan-en">
                      {{ $t("banner_slogan_line2") }}<br />
                      {{ $t("banner_slogan_line3") }}
                    </p>
                  </div>
                </div>
                <div class="products-section">
                  <div class="product-grid-1">
                    <div class="product-item gray">
                      <div class="product-name">
                        {{ $t("particle_detector") }}
                      </div>
                    </div>
                    <div class="product-item white">
                      <div class="product-name">{{ $t("detector_xray") }}</div>
                    </div>
                    <div class="product-item white product-item-img-large">
                      <img :src="banner03" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="part-02">
              <div class="media-wrapper">
                <div class="products-section">
                  <div class="product-grid-2">
                    <div class="product-item red">
                      <div class="product-name">
                        {{ $t("detector_neutrino") }}
                      </div>
                    </div>
                    <div class="product-item gray">
                      <div class="product-name">
                        {{ $t("detector_electron") }}
                      </div>
                    </div>
                    <div class="product-item product-item-spacer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="carousel-btn prev-btn" @click="prevSlide">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path
            fill="currentColor"
            d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
          />
        </svg>
      </button>

      <!-- <div class="carousel-controls">
        <div class="carousel-dots bg-white">
          <span
            v-for="index in 3"
            :key="index"
            :class="{ active: currentIndex === index - 1 }"
            @click="goToSlide(index - 1)"
          ></span>
        </div>
      </div> -->

      <button class="carousel-btn next-btn" @click="nextSlide">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path
            fill="currentColor"
            d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
          />
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
import banner01 from "@/assets/images/home/banner-01.png";
import banner02 from "@/assets/images/home/banner-02.png";
import banner03 from "@/assets/images/home/banner-03.png";
export default {
  name: "Banner",
  data() {
    return {
      banner01,
      banner02,
      banner03,
      currentIndex: 0,
      intervalTime: 5000,
      autoPlay: null,
      touchStartX: 0,
      dragOffset: 0,
      isDragging: false,
    };
  },
  computed: {
    trackStyle() {
      let baseTransform = `translateX(calc(-${(100 / 3) * this.currentIndex}%))`;
      if (this.dragOffset !== 0) {
        baseTransform = `translateX(calc(-${(100 / 3) * this.currentIndex}% + ${this.dragOffset}px))`;
      }
      return {
        transform: baseTransform,
        width: "300%",
        height: "100%",
        transition: this.isDragging ? 'none' : 'transform 0.5s ease',
      };
    },
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % 3;
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + 3) % 3;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    startLunbo() {
      this.pauseLunbo();
      this.autoPlay = setInterval(this.nextSlide, this.intervalTime);
    },
    pauseLunbo() {
      if (this.autoPlay) {
        clearInterval(this.autoPlay);
        this.autoPlay = null;
      }
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.isDragging = true;
      this.dragOffset = 0;
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      const currentX = e.touches[0].clientX;
      this.dragOffset = currentX - this.touchStartX;
    },
    onTouchEnd() {
      this.isDragging = false;
      const diff = this.dragOffset;
      this.dragOffset = 0;
      if (Math.abs(diff) > 50) {
        if (diff < 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    },
  },
  mounted() {
    this.autoPlay = setInterval(this.nextSlide, this.intervalTime)
  },
  beforeDestroy() {
    if (this.autoPlay) {
      clearInterval(this.autoPlay);
    }
  },
};
</script>

<style scoped lang="less">
.banner {
  position: relative;
  overflow: hidden;
  height: calc(100vh - 72px + 500px);
}

.carousel-container {
  /* position: relative; */
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
  height: 800px;
  width: 300%;
  flex: 0 0;
}

.carousel-slide {
  width: 100vw;
  position: relative;
  box-sizing: border-box;

  &.slide-1,
  &.slide-2,
  &.slide-3 {
    background: linear-gradient(
      180deg,
      #89031c 0%,
      #89031c 60%,
      #fff 60%,
      #fff 800px
    );
  }
}

.slide-content {
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;

  .part-01 {
    background: #89031c;
    height: calc(100vh - 72px);
  }
  .media-wrapper {
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .part-01 .media-wrapper {
    align-items: flex-end;
  }
  .part-02 .media-wrapper {
    align-items: flex-start;
  }
}

.top-section {
  position: absolute;
  left: 0;
  top: 25%;
  transition: all 0.3s ease;
  &:hover {
    /* transform  : translateY(-5px); */
    .slogan {
      transform: scale(1.05);
    }
  }
}

.company-logo {
  font-size: 32px;
  font-weight: bold;
  color: white;
  margin-bottom: 40px;
  letter-spacing: 2px;
}

.slogan {
  color: white;
  transition: all 0.3s ease;
  h1 {
    font-size: 60px;
    font-weight: bold;
    margin: 0 0 20px 0;
    line-height: 1.2;
  }
}

.slogan-en {
  font-size: 48px;
  line-height: 1.4;
  margin: 0;
  opacity: 0.9;
  text-align: left;
}

/* 产品网格样式 - 匹配图片布局 */
.products-section {
  flex: 1;
}

.product-grid-1 {
  height: 60%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  .product-item {
    width: 300px;
    height: 300px;
  }
  .product-item-img-large {
    width: 500px;
    height: 500px;
    padding: 0;
  }
}
.product-grid-2 {
  height: 300px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  .product-item {
    width: 300px;
    height: 300px;
  }
  .product-item-spacer {
    width: 200px;
    height: 300px;
  }
}

.product-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 30px;
  transition: all 0.3s ease;

  .product-name {
    font-size: 24px;
    font-weight: bold;
    text-align: left;
  }
  &.gray {
    background-color: rgb(77 77 77);
    color: rgb(252 252 252);
  }
  &.white {
    background-color: #fff;
    color: rgb(1 1 1);
  }
  &.red {
    background-color: #89031c;
    color: rgb(252 252 252);
  }
  img {
    width: 100%;
    height: 100%;
  }
  .product-desc {
    font-size: 20px;
    text-align: left;
  }
  &.gray:hover,
  &.white:hover,
  &.red:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    img {
      /* transform: scale(1.1); */
    }

    .item-name {
      transform: scale(1.05);
    }
  }
}

/* PET/CT区域样式 */
.petct-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.petct-title {
  font-size: 42px;
  font-weight: bold;
  color: white;
  margin-bottom: 50px;
}

.petct-variants {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 30px;
  max-width: 900px;
}

.variant {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 25px;
  font-size: 24px;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* 探测器网格样式 */
.detector-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detector-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 40px;
  max-width: 700px;
}

.detector-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 40px;
  font-size: 28px;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* BOOM部分样式 */
.boom-section {
  position: absolute;
  bottom: 60px;
  right: 80px;
  text-align: right;
  color: white;

  .boom-title {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .boom-subtitle {
    font-size: 18px;
    opacity: 0.9;
    margin-bottom: 20px;
  }

  .pnl {
    font-size: 24px;
    line-height: 1.3;
  }
}

/* 右侧固定区域 */
.fixed-right-side {
  flex: 0 0 20%;
  background: linear-gradient(135deg, #212121 0%, #424242 100%);
  color: white;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.applications-box {
  .app-item {
    font-size: 22px;
    padding: 20px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);

    &:last-child {
      border-bottom: none;
    }
  }
}

.award-box {
  .award-tag {
    background: white;
    color: #000;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
  }

  .award-info {
    text-align: center;

    .wipo {
      font-size: 20px;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .date {
      font-size: 16px;
      opacity: 0.8;
      margin-bottom: 15px;
    }

    .award {
      font-size: 18px;
      color: white;
      font-weight: bold;
    }
  }
}

/* 轮播指示器 */
.carousel-controls {
  position: absolute;
  bottom: 540px;
  left: 80px;
}

.carousel-dots {
  display: flex;
  gap: 15px;
}

.carousel-btn {
  position: absolute;
  top: calc(50% - 300px);
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s ease;
  z-index: 100;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  svg {
    width: 24px;
    height: 24px;
  }
}

.prev-btn {
  left: 20px;
}

.next-btn {
  right: 20px;
}

.carousel-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s;

  &.active {
    background: white;
    transform: scale(1.2);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.6);
  }
}
.bg-white span {
  background: rgba(204, 204, 204, 0.3);
  &.active {
    background: #ccc;
  }
  &:hover {
    background: rgba(204, 204, 204, 0.6);
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .carousel-container {
    flex-direction: column;
  }

  .carousel-track {
    flex: 0 0 70%;
    height: 600px;
  }

  .fixed-right-side {
    flex: 0 0 30%;
    flex-direction: row;
    padding: 30px 40px;
  }

  .applications-box {
    flex: 1;
  }

  .award-box {
    flex: 1;
  }
}

@media (max-width: 768px) {
  .banner {
    height: auto;
    min-height: 100vh;
  }

  .carousel-track {
    height: auto;
    min-height: 600px;
  }

  .carousel-slide {
    padding: 0;
  }

  .slide-content {
    .part-01 {
      height: auto;
      min-height: 60vh;
    }
    .media-wrapper {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .products-section {
    width: 100%;
  }

  .top-section {
    position: relative;
    left: 0;
    top: auto;
    padding: 30px 15px;
  }

  .slogan {
    h1 {
      font-size: 28px;
      text-align: left;
    }
  }

  .slogan-en {
    font-size: 18px;
    line-height: 1.3;
  }

  .product-grid-1 {
    height: auto;
    flex-direction: column;
    align-items: center;
    padding: 15px;

    .product-item {
      width: 100%;
      height: auto;
      min-height: 80px;
    }
  }

  .product-grid-2 {
    height: auto;
    flex-direction: column;
    align-items: center;
    padding: 15px;

    .product-item {
      width: 100%;
      height: auto;
      min-height: 80px;
    }
  }

  .product-grid-1 .product-item-img-large {
    width: 100%;
    height: auto;
  }

  .product-item-spacer {
    display: none;
  }

  .company-logo {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .product-item,
  .variant,
  .detector-item {
    padding: 20px;
    font-size: 18px;
  }

  .boom-section {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 40px;
    text-align: center;
  }

  .fixed-right-side {
    flex-direction: column;
    padding: 30px 20px;
  }

  .applications-box .app-item {
    font-size: 18px;
    padding: 15px 0;
  }

  .carousel-controls {
    display: none;
  }

  .carousel-btn {
    top: 50%;
    width: 44px;
    height: 44px;
  }

  .carousel-dots span {
    width: 44px;
    height: 44px;
    min-height: 44px;
  }

  .prev-btn {
    left: 10px;
  }
  .next-btn {
    right: 10px;
  }
}
@media (width > 1920px) {
  .media-wrapper {
    max-width: 1680px;
  }
}
@media (width <= 1920px) {
  .media-wrapper {
    max-width: 1400px;
  }
}
@media (width <= 1680px) {
  .media-wrapper {
    max-width: 1400px;
  }
}
@media (width <= 1440px) {
  .slogan h1 {
    font-size: 48px;
  }
  .slogan-en {
    font-size: 36px;
  }
}
@media (width <= 1400px) {
  .media-wrapper {
    max-width: 1200px;
  }
}
@media (width <= 1200px) {
  .media-wrapper {
    width: 100%;
    padding: 0 20px;
    .top-section {
      left: 20px;
    }
  }
}
@media (max-width: 768px) {
  .media-wrapper .top-section {
    left: 0;
  }
}
/* r14: inset opening copy with the common corporate header. */
@media(min-width:769px){.slide-content .media-wrapper .top-section{left:34px;right:34px}}
</style>